import { FC } from 'react';

import { Card, CardTitle, Field, FormGrid, Input, Select } from '../../../ui';
import { PaynowForm, SetPaynowField, parseKind } from './types';

type PayNowSettingsCardProps = {
  form: PaynowForm;
  setField: SetPaynowField;
  username: string | null;
};

/** Where the payment goes: how it is identified and what the payer sees. */
const PayNowSettingsCard: FC<PayNowSettingsCardProps> = ({ form, setField, username }) => (
  <Card className="paymentCard">
    <CardTitle>PayNow settings</CardTitle>
    <FormGrid columns={2}>
      <Field id="paynow-type" label="PayNow ID type">
        <Select value={form.kind} onChange={(changed) => setField('kind', parseKind(changed.target.value))}>
          <option value="mobile">Mobile number</option>
          <option value="uen">Business UEN</option>
        </Select>
      </Field>

      <Field id="paynow-value" label={form.kind === 'mobile' ? 'Mobile number' : 'UEN'}>
        <Input
          value={form.value}
          onChange={(changed) => setField('value', changed.target.value)}
          placeholder={form.kind === 'mobile' ? '+65 9123 4567' : '201403121W'}
          inputMode={form.kind === 'mobile' ? 'tel' : 'text'}
          autoComplete="off"
        />
      </Field>

      <Field id="paynow-name" label="Display name" span="full" description="What the payer sees on their banking app.">
        <Input
          value={form.name}
          onChange={(changed) => setField('name', changed.target.value)}
          placeholder={username ?? ''}
          maxLength={25}
          autoComplete="off"
        />
      </Field>
    </FormGrid>
  </Card>
);

export default PayNowSettingsCard;
